import React, { Component } from 'react';
import './Addresses.css';
import { Row, Col, Input, Card, CardHeader, CardBody, Collapse } from 'reactstrap';
import AddressForm from './AddressForm';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import CompanyContext from '../../auth/CompanyContext';
class Addresses extends Component {
    static contextType = CompanyContext;

    constructor(props) {

        super(props);
        this.state = {
            secID: this.props.secID,
            orgID: this.props.orgID,
            loading: true,
            addresses: [],
            notesCategories: [],
            debug_message: null,
            prevLinkedID: null,
            addCategoryCommentsArray: [],
            editCategoryCommentsArray: [],
            selectValue: '',
            editID: 0,
            open: true
        };
    }


    componentDidMount() {
        this.setState(
            { loading: true },
            () => {
                this.getAddresses();
                if (this.props.useProvidedNotesCategories) {
                    this.setState({ notesCategories: Array.isArray(this.props.notesCategories) ? this.props.notesCategories : [] });
                } else if (Array.isArray(this.props.notesCategories) && this.props.notesCategories.length > 0) {
                    this.setState({ notesCategories: this.props.notesCategories });
                } else {
                    this.getNotesCategories();
                }
            }
        );
        this.props.setAddressesHandleAdd(this.handleAddSubmit);
    }

    componentDidUpdate(prevProps) {
        if (JSON.stringify(this.props.searchOptions) !== JSON.stringify(prevProps.searchOptions)) {
            this.setState(
                { loading: true },
            );
        }
        if (this.props.notesCategories !== prevProps.notesCategories && Array.isArray(this.props.notesCategories)) {
            this.setState({ notesCategories: this.props.notesCategories });
        }
    }

    handleAddSubmit = () => {
        // console.log('Addresses.js/handleAddSubmit')
        let dataObj = {};
        let active = true;
        this.props.addCategoryCommentsArray.filter(item => item.value !== '' && item.value != null).forEach(item => {
            if (item.type === 'Inactive' && (item.value === 1 || Boolean(item.value))) {
                active = false;
            } else {
                dataObj[item.type] = item.value;
            }
        })
        this.setState({
            loading: true
        }, () => {
            fetch('/api/addresses/', {
                method: 'POST',
                body: JSON.stringify({
                    data: JSON.stringify(dataObj),
                    auth0: this.props.user,
                    active: active,
                    secID: this.state.secID
                }),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.props.clientToken,
                    'X-Database': this.context.company
                }
            })
                .then(results => results.json())
                .then(results => {
                    if (results.debug_message == null) {
                        this.props.handleCancel();
                        this.getAddresses();
                        this.props.setUnsavedChanges(false);
                    }
                });
        }
        );

    }

    handleCancel = (e) => {
        // console.log('Addresses.js/handleCancel (e)', e.target.name, e.target.value)
        this.setState(
            {
                selectValue: '',
                loading: false,
                // addCategoryCommentsArray: [],
                editCategoryCommentsArray: []
            }, () => {
                this.getAddresses();
                this.props.setUnsavedChanges(false);
            }
        );
    }

    handleEditSubmit = (e) => {
        // console.log('Addresses.js/handleEditSubmit (e)', e.target.name, e.target.value);
        let dataObj = {};
        let active = true;
        this.state.editCategoryCommentsArray.filter(item => item.value !== '' && item.value != null).forEach(item => {
            if (item.type === 'Inactive' && (item.value === 1 || Boolean(item.value))) {
                active = false;
            } else {
                dataObj[item.type] = item.value;
            }
        })
        this.setState(
            { loading: true },
        );
        fetch('/api/addresses/' + e.target.value, {
            method: 'PUT',
            body: JSON.stringify({
                data: JSON.stringify(dataObj),
                auth0: this.props.user,
                active: active
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.debug_message?.error == null) {
                    // this.handleDelete({ target: { value: results.linkedID } });
                    this.setState({
                        editID: 0,
                        editCategoryCommentsArray: []
                    }, () => {
                        this.getAddresses();
                        this.props.setUnsavedChanges(false);
                    })
                }
            });
    }

    handleDelete = (e) => {
        // console.log('Addresses.js/handleDelete (e)', e.target.name, e.target.value)
        fetch('/api/addresses/' + e.target.value, {
            method: 'DELETE',
            //body: json_request,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.debug_message == null) {
                    this.setState(
                        { editID: 0, loading: false },
                        () => {
                            this.getAddresses();
                            this.props.setUnsavedChanges(false);
                        }
                    );
                }
            });
    }

    handleEditSwap = (val) => {
        // console.log('Addresses.js/handleEditSwap (val)', val)
        this.displayEditCategories(val);
        this.props.setUnsavedChanges(false);
        this.setState({
            otherCategories: {},
            editID: val !== this.state.editID ? val : 0
        });
    }

    getNotesCategories() {
        if (this.props.useProvidedNotesCategories) {
            this.setState({
                loading: false,
                notesCategories: Array.isArray(this.props.notesCategories) ? this.props.notesCategories : []
            });
            return;
        }
        if (Array.isArray(this.props.notesCategories) && this.props.notesCategories.length > 0) {
            this.setState({
                loading: false,
                notesCategories: this.props.notesCategories
            });
            return;
        }
        // console.log('Addresses.js/getNotesCategories')
        fetch('/api/notesCategories/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                this.setState({
                    loading: false,
                    notesCategories: results.data.filter(item => item.type === 'Address')[0]?.children || [],
                    debug_message: results.debug_message,
                });
            });
        return;
    }

    getAddresses() {
        // console.log('Addresses.js/getAddresses')
        // this.props.onGetMetaData();
        fetch('/api/addresses/' + this.props.secID, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                this.setState({
                    loading: false,
                    addresses: results.data,
                    debug_message: results.debug_message,
                }, () => {
                    this.props.setAddresses(this.state.addresses);
                });
            });
        return;
    }

    displayCategories = (e) => {
        // console.log('Addresses.js/displayCategories (e)', e.target.name, e.target.value)
        const categoryList = typeof (this.state.notesCategories.filter(
            item => parseInt(item.ID) === parseInt(e.target.value)
        )[0]) !== 'undefined' ? this.state.notesCategories.filter(
            item => parseInt(item.ID) === parseInt(e.target.value)
        )[0].children : [];
        categoryList.forEach((item) => { item.value = null; })
        const categoryValue = parseInt(e.target.value);
        this.setState({
            selectValue: categoryValue,
            // addCategoryCommentsArray: categoryList
        });
    };

    displayEditCategories = (val) => {
        // console.log('Addresses.js/displayEditCategories (val)', val)
        const dataList = typeof (this.state.addresses.filter(
            item => item.linkedID === val
        )[0]) !== 'undefined' ? this.state.addresses.filter(
            item => item.linkedID === val
        )[0] : [];
        const categoryList = this.state.notesCategories/*.filter(
            item => Object.keys(dataList.children).findIndex(key => key === item.type) > -1
        );*/
        categoryList.forEach(item => {
            const matchData = Object.keys(dataList.children).filter(key => key === item.type);
            if (matchData.length > 0) {
                item.value = dataList.children[matchData[0]];
                // item.commentID = matchData[0].ID;
                // item.parentID = matchData[0].parentID;
                // item.error = false;
            } else {
                item.value = "";
                // item.commentID = null;
                // item.parentID = null;
                // item.error = false;
            }
        })
        if (categoryList.findIndex(item => item.type === "Inactive") > -1) {
            categoryList[categoryList.findIndex(item => item.type === "Inactive")].value = !dataList.active;
        }
        // console.log(dataList, categoryList)
        this.setState({
            editCategoryCommentsArray: categoryList
        });
    };

    setComment = (e) => {
        // console.log('Addresses.js/setComment (e)', e.target.name, e.target.value)
        const commentsArray = [...this.props.addCategoryCommentsArray];
        commentsArray.filter(
            item => parseInt(item.ID) === parseInt(e.target.name)
        )[0].value = e.target.value;
        // this.setState({
        //     addCategoryCommentsArray: commentsArray
        // });
        this.props.setUnsavedChanges(true);
    }

    setEditComment = (e) => {
        // console.log('Addresses.js/setEditComment (e)', e.target.name, e.target.value)
        const commentsArray = [...this.state.editCategoryCommentsArray];
        commentsArray.filter(
            item => parseInt(item.ID) === parseInt(e.target.name)
        )[0].value = e.target.value;
        //dataArray.filter(item => parseInt(item.ID) === parseInt(e.target.name))[0]
        this.setState({
            editCategoryCommentsArray: commentsArray
        });
        this.props.setUnsavedChanges(true);
    }

    changeComment = (e, validation = null) => {
        // console.log('Addresses.js/changeComment (e)', e.target.name, e.target.value)
        const dataArray = [...this.state.editCategoryCommentsArray]
        dataArray.filter(
            item => parseInt(item.ID) === parseInt(e.target.name)
        )[0].value = (e.target.type !== 'checkbox' ? e.target.value : e.target.checked);
        if (validation != null) {
            const matches = String(e.target.value).match(new RegExp(validation));
            dataArray.filter(
                item => parseInt(item.ID) === parseInt(e.target.name)
            )[0].error = (matches == null);
        }
        if (e.target.value === '' || e.target.value == null) {
            dataArray.filter(
                item => parseInt(item.ID) === parseInt(e.target.name)
            )[0].error = false;
        }
        this.setState({
            editCategoryCommentsArray: dataArray
        });
        this.props.setUnsavedChanges(true);
    }

    isFormBlank(array) {
        // console.log('Addresses.js/isFormBlank (array)', array)
        let retBool = true;
        array.forEach(row => {
            if (row.value !== null && row.value !== '') { retBool = false; }
        })
        return retBool;
    }

    showHide() {
        // console.log('Addresses.js/showHide')
        this.setState({
            open: !this.state.open
        })
    }

    render() {
        return (<>
            {this.state.addresses.length > 0 && <Card>
                <CardHeader onClick={() => this.showHide()}>
                    <Row className="align-items-center">
                        <Col className="text-left">
                            <h3>Addresses</h3>
                        </Col>
                        {this.state.addresses.findIndex(item => !item.active) > -1 && <Col className="col-xs-4 text-right" onClick={(e) => e.stopPropagation()} >
                            <Input
                                type="checkbox"
                                checked={this.state.showInactiveAddresses}
                                onClick={() => this.setState({ showInactive: !this.state.showInactive })}
                            /> Show Inactive
                        </Col>}
                        <Col xs="1" className="text-right">
                            {(this.state.open) ? <FontAwesomeIcon icon={faChevronUp} /> : <FontAwesomeIcon icon={faChevronDown} />}
                        </Col>
                    </Row>
                </CardHeader>
                <Collapse isOpen={this.state.open}>
                    <CardBody>
                        <AddressForm
                            clientToken={this.props.clientToken}
                            editID={this.state.editID}
                            addresses={[...this.state.addresses].filter(row => (this.state.showInactive || (!this.state.showInactive && row.active)))}
                            notesCategories={this.state.notesCategories}
                            justNotes={false}
                            // addCategoryCommentsArray={this.state.addCategoryCommentsArray}
                            editCategoryCommentsArray={this.state.editCategoryCommentsArray}
                            selectValue={this.state.selectValue}
                            otherCategories={this.state.otherCategories}
                            onGetMetaData={this.onGetMetaData}
                            handleCancel={this.handleCancel}
                            handleAddSubmit={this.handleAddSubmit}
                            handleEditSubmit={this.handleEditSubmit}
                            handleDelete={this.handleDelete}
                            handleEditSwap={this.handleEditSwap}
                            displayCategories={this.displayCategories}
                            displayEditCategories={this.displayEditCategories}
                            setComment={this.setComment}
                            setEditComment={this.setEditComment}
                            changeComment={this.changeComment}
                            changeOtherCategory={this.changeOtherCategory}
                            addCategory={this.addCategory}
                            userPermissions={this.props.userPermissions}
                        // marketingActivities={this.state.marketingActivities.filter(activity => activity.Category === 'Emails')}
                        />
                    </CardBody>
                </Collapse>
            </Card>}
        </>
        );
    }
}



export default Addresses;
